import layout from './modules/layout.js';
import store from './modules/store.js'; // 商城
import web from './modules/web.js';
import meetingConfig from './modules/meetingConfig.js';
import authority from './modules/authority.js';
import formConfig from './modules/formConfig.js';
import forum from './modules/forum.js';
import goods from './modules/goods.js';
import hotel from './modules/hotel.js';
import notice from './modules/notice.js';
import program from './modules/program.js';
import form from './modules/form.js';
import staff from './modules/staff.js';
import user from './modules/user.js';
import webConfig from './modules/web-config.js';
import forumViews from './modules/forum-views.js';
import submission from './modules/submission.js';
import mobileConfig from './modules/mobile-config.js';

export default {
    title: '中文',
    layout,
    web,
    meetingConfig,
    store,
    authority,
    formConfig,
    forum,
    goods,
    hotel,
    notice,
    program,
    form,
    staff,
    user,
    webConfig,
    forum_views: forumViews,
    submission,
    mobileConfig
};
